import { type Row, flexRender } from "@tanstack/react-table";
import { useAtomValue } from "jotai";
import React, { Fragment } from "react";

import { cn } from "~/components/ui/cn";
import type { StockProduct } from "~/views/stock/stock-product-list";

import { activeStockIdState } from "./stock-state";

export function getStockValue(stock: number | null | undefined) {
  if (stock === null) {
    return 1000;
  }
  return stock;
}

export function StockProductListItem({
  row,
  ...props
}: {
  row: Row<StockProduct>;
} & React.ComponentProps<"div">) {
  const activeStockId = useAtomValue(activeStockIdState);

  return (
    <div
      className={cn(
        "stock-product-list-item relative grid border-b border-gray-100 transition-colors duration-150 last:border-none hover:bg-gray-50/30",
        {
          "bg-gray-50": activeStockId === row.original.stockId,
        },
      )}
      {...props}
    >
      {row.getVisibleCells().map((cell) => (
        <Fragment key={cell.id}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </Fragment>
      ))}
    </div>
  );
}
